import React from 'react'

const Footer = () => {
const year = new Date().getFullYear()

return (
    <div className="footer_container ">
            <ul className="profile__social">
                    <a href="https://www.linkedin.com/in/ubaldo-canseco-hernandez/" className="profile__social_link">
                            <i className="fi fi-brands-linkedin"></i>
                    </a>
                    <a href="https://github.com/UbaldoCans" className="profile__social_link">
                            <i className="fi fi-brands-github"></i>
                    </a>
            </ul>
            <p>&copy; Ubaldo Canseco Hernandez Desarrollador, {year}. Todos los derechos reservados.</p>
    </div>
)
}

export default Footer